module.exports = __webpack_public_path__ + "static/CrimsonText-Regular-d28795070eab4cab4d41ca6670ed80f3.woff2";